// import React, { useEffect, useState } from 'react';
// import './App.css';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   Outlet,
//   useLocation,
// } from 'react-router-dom';

// import Layout from './Components/Layout/layout';
// import Dashboard from './Components/Dashboard/Dashboard';
// import Categories from './Components/Categories/Categories';
// import Products from './Components/Products/productsList';
// import OrdersList from './Components/Orders/ordersList';
// import DeletedOrders from './Components/Orders/DeletedOrders'; 
// import CustomersList from './Components/Customers/customersList';
// import CustomersDetail from './Components/Customers/customerDetail';
// import SignIn from './SignIn/signIn';
// import Operations from './Components/Operations/operations'; 

// const API_BASE_URL = process.env.REACT_APP_EP || 'http://localhost:5000';

// // This component protects all routes nested under it
// const ProtectedShell = () => {
//   const [status, setStatus] = useState('checking');
//   const location = useLocation();

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
//           method: 'GET',
//           credentials: 'include',
//         });
//         setStatus(res.ok ? 'authed' : 'unauth');
//       } catch (err) {
//         console.error('Auth check failed:', err);
//         setStatus('unauth');
//       }
//     };

//     checkAuth();
//   }, []);

//   if (status === 'checking') {
//     return null;
//   }

//   if (status === 'unauth') {
//     return <Navigate to="/signin" replace state={{ from: location }} />;
//   }

//   return (
//     <Layout>
//       <Outlet />
//     </Layout>
//   );
// };

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Public route */}
//         <Route path="/signin" element={<SignIn />} />

//         {/* Protected routes */}
//         <Route element={<ProtectedShell />}>
//           <Route path="/" element={<Dashboard />} />
//           <Route path="/categories" element={<Categories />} />
//           <Route path="/products" element={<Products />} />
//           <Route path="/orders" element={<OrdersList />} />
//           <Route path="/orders/deleted" element={<DeletedOrders />} />
//           <Route path="/customers" element={<CustomersList />} />
//           <Route path="/customers/:id" element={<CustomersDetail />} />
//           <Route path="/operations" element={<Operations />} />
//         </Route>

//         {/* Fallback */}
//         <Route path="*" element={<Navigate to="/signin" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import React, { useEffect, useState } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';

import Layout from './Components/Layout/layout';
import Dashboard from './Components/Dashboard/Dashboard';
import Categories from './Components/Categories/Categories';
import Products from './Components/Products/productsList';
import OrdersList from './Components/Orders/ordersList';
import DeletedOrders from './Components/Orders/DeletedOrders'; 
import CustomersList from './Components/Customers/customersList';
import CustomersDetail from './Components/Customers/customerDetail';
import SignIn from './SignIn/signIn';
import Operations from './Components/Operations/operations';
import Marketing from './Components/Marketing/marketing'; // NEW

const API_BASE_URL = process.env.REACT_APP_EP || 'http://localhost:5000';

const ProtectedShell = () => {
  const [status, setStatus] = useState('checking');
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
          method: 'GET',
          credentials: 'include',
        });
        setStatus(res.ok ? 'authed' : 'unauth');
      } catch (err) {
        console.error('Auth check failed:', err);
        setStatus('unauth');
      }
    };

    checkAuth();
  }, []);

  if (status === 'checking') {
    return null;
  }

  if (status === 'unauth') {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/signin" element={<SignIn />} />

        {/* Protected routes */}
        <Route element={<ProtectedShell />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/products" element={<Products />} />
          <Route path="/orders" element={<OrdersList />} />
          <Route path="/orders/deleted" element={<DeletedOrders />} />
          <Route path="/customers" element={<CustomersList />} />
          <Route path="/customers/:id" element={<CustomersDetail />} />
          <Route path="/operations" element={<Operations />} />
          <Route path="/marketing" element={<Marketing />} /> {/* NEW */}
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </Router>
  );
}

export default App;